import { useRef, useEffect, EffectCallback } from "react";

export function usePrevious<T>(value: T) {
  const ref = useRef(value);

  return ref.current;
}

function useChanged<T>(effect: EffectCallback, value: T) {
  const prev = usePrevious(value);

  useEffect(() => {
    if (prev !== value) {
      return effect();
    }
  }, [value]);
}

export default useChanged;
